import { createApp } from 'vue'
import element from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import App from '@/App.vue'
import router from '@/router'
import cookie from 'js-cookie'
import httpRequest from '@/utils/httpRequest'
import net from '@/utils/net'

const app = createApp(App)
app.use(element)
app.use(router)
app.config.globalProperties.$cookie=cookie;
app.config.globalProperties.$http=httpRequest;
app.config.globalProperties.$net=net;
app.mount('#app')
export default app